const ABBREV_LEN = 30;

export { ABBREV_LEN };
